module.exports = __webpack_public_path__ + "img/ci_filter_on.5ad298cb.svg";